/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    disabled: PropTypes.bool,
    title: PropTypes.bool,
    critical: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'a',
    disabled: false,
    title: false,
    critical: false,
};

const PopoverItem = (props) => {
    const classNames = [
        'c-popover__container-item',
        props.disabled ? 'c-popover__container-item--disabled' : '',
        props.title ? 'c-popover__container-item--title' : '',
        props.critical ? 'c-popover__container-item--error' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];

    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

PopoverItem.propTypes = propTypes;

PopoverItem.defaultProps = defaultProps;

export default PopoverItem;
